import { createNavigationView } from './index'

const Profile = () => import('../components/Profile/Profile.vue')
const AcceptPrivacyPolicyModal = () => import('../components/Profile/AcceptPrivacyPolicyModal')
const ProfileSidebar = () => import('../components/Profile/ProfileSidebar.vue')
const EditProfile = () => import('../components/Profile/EditProfile.vue')
const ChangePassword = () => import('../components/Profile/ChangePassword.vue')
const ChangeEmail = () => import('../components/Profile/ChangeEmail.vue')
const IncompleteProfile = () => import('../components/Profile/IncompleteProfile.vue')
const FeatureUnavailable = () => import('../components/Profile/FeatureUnavailable.vue')
const AdjudicatedAdverts = () => import('../components/AdjudicatedAdverts/AdjudicatedAdverts.vue')

const CompetencyTest = () => import('../components/Surveys/CompetencyTest.vue')
const CompetencyTestEvaluation = () => import('../components/Surveys/CompetencyTestEvaluation.vue')

const BidsModalAuthenticator = () => import('../components/BidSessions/BidsModalAuthenticator.vue')
const AdvertDetailsAuthenticator = () => import('../components/Arena/AdvertDetailsAuthenticator.vue')

export const routes = () => [
  {
    path: '/kompetencia-teszt/',
    components: {
      default: CompetencyTest,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Competency test',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/kompetencia-teszt/kiertekeles',
    components: {
      default: CompetencyTestEvaluation,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Competency test',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/sikeres-borze-hirdetesek',
    components: {
      default: AdjudicatedAdverts,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: 'ajanlat/:id/elozmeny',
        component: BidsModalAuthenticator,
        props: true,
        meta: {
          isModal: true,
          pageTitle: 'Adjudicated adverts - Bid History',
          requiresAuth: true,
          requiresValidProfile: true,
          wrapperClass: 'profile-wrapper'
        }
      },
      {
        path: ':id',
        component: AdvertDetailsAuthenticator,
        props: route => ({ id: route.params.id }),
        meta: {
          isModal: true,
          pageTitle: 'Adjudicated adverts - Details',
          requiresAuth: true,
          requiresValidProfile: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    meta: {
      pageTitle: 'Adjudicated adverts',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/profil/szemelyes-adatlapom',
    components: {
      default: EditProfile,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Profile - Personal Details',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/profil/jelszo-megvaltoztatasa',
    components: {
      default: ChangePassword,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Profile - Change Password',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/profil/email-cim-megvaltoztatasa',
    components: {
      default: ChangeEmail,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Profile - Change Email Address',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/profil/hianyzo-adatok',
    components: {
      default: IncompleteProfile,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Profile - Missing Details',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/a-funkcio-nem-elerheto',
    components: {
      default: FeatureUnavailable,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    meta: {
      pageTitle: 'Feature Not Available',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  },
  {
    path: '/profil/:view',
    components: {
      default: Profile,
      navigation: createNavigationView('static'),
      sidebar: ProfileSidebar
    },
    children: [
      {
        path: '/profil/adatvedelmi-tajekoztato-elfogadasa',
        component: AcceptPrivacyPolicyModal,
        meta: {
          isModal: true,
          pageTitle: 'Profile - Accept privacy policy',
          requiresAuth: true,
          wrapperClass: 'profile-wrapper'
        }
      }
    ],
    props: {
      default: true
    },
    meta: {
      pageTitle: 'Profile',
      requiresAuth: true,
      wrapperClass: 'profile-wrapper'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/profile.js